/**
 * Converts an RGB array to a hex color string
 */
export function rgbToHex(rgb: Array<number>): string {
    let color = '#';
    for (let i = 0; i < 3; i += 1) {
        color += `00${rgb[i].toString(16)}`.slice(-2);
    }
    return color;
}

/**
 * Generates a color and its complementary color from a string
 */
export function stringToColor(string: string): [string, string] {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    const rgb = new Array<number>(3);
    for (i = 0; i < 3; i += 1) {
        rgb[i] = (hash >> (i * 8)) & 0xff;
    }
    /* eslint-enable no-bitwise */

    const color = rgbToHex(rgb);
    const m = Math.min(rgb[0], rgb[1], rgb[2]) + Math.max(rgb[0], rgb[1], rgb[2]);
    const complementaryRgb = [(m - rgb[0]), m - rgb[1], m - rgb[2]];
    const complementaryColor = rgbToHex(complementaryRgb);

    return [color, complementaryColor];
}
